module.exports = __webpack_public_path__ + "img/daren_8.9a2247cb.png";